import React, { useState, useEffect } from 'react'
import { Spin, Pagination, message } from 'antd'
import { Link } from 'react-router-dom'
import UseDebounce from '../helpers/UseDebounce'
import CombineShipTable from './CombineShipTable'
import CombineShipFilter from './Filters/CombineShipFilter'
// import ModalEditInfoBox from './ModalEditInfoBox'
import { getListCombineShip } from '../../../services/api/apiCombineShip'

function CombineShipPage() {
    const [listCombineShip, setListCombineShip] = useState([])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [status, setStatus] = useState('')
    const [itemType, setItemType] = useState('')
    const [lineShip, setLineShip] = useState('')
    const [batch, setBatch] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [createdStart, setCreatedStart] = useState('')
    const [createdEnd, setCreatedEnd] = useState('')
    const [limit, setLimit] = useState(20)
    const [total, setTotal] = useState(0)
    const [arrSelected, setArrSelected] = useState([])
    const [selectAll, setSelectAll] = useState(false)
    const [packingStart, setPackingStart] = useState('')
    const [packingEnd, setPackingEnd] = useState('')

    const fetchCombineShip = async () => {
        setLoading(true)
        const payload = {
            page,
            limit,
        }
        if (status) payload.status = status
        if (lineShip) payload.line_ship = lineShip
        if (batch.length) payload.ids = batch
        if (itemType) payload.type = itemType
        if (createdStart && createdEnd) payload.created = {
            from: createdStart,
            to: createdEnd,
        }

        if (packingStart && packingEnd) payload.packing_date = {
            from: packingStart,
            to: packingEnd,
        }

        try {
            const { data, success, message: mess } = await getListCombineShip({ ...payload })
            
            if (success) {
                const { total, items } = data
                setListCombineShip(items)
                setTotal(total)
            } else {
                message.error(mess)
            }

            setLoading(false)
        } catch (error) {
            message.error(error.message || 'Unknown error.')
        } finally {
            setLoading(false)
        }

    }

    const debounceSearch = UseDebounce(batch, 1000)

    const handlePageChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const handleChangeStatus = (value) => {
        setStatus(value)
        setPage(1)
    }

    const handleChangeItemType = (value) => {
        setItemType(value)
        setPage(1)
    }

    const handleChangeLineShip = (value) => {
        setLineShip(value)
        setPage(1)
    }

    const handleChangeBatch = (value) => {
        setSearchValue('')
        const Value = [...new Set(value.filter(i => !!i && i).map(i => i.replace(/#|'|_\d+/g, "")))]
        setBatch(Value)
        setPage(1)
    }
    const handleSearchBatch = (value) => {
        if (value.includes(',') || value.includes(' ')) {
            setSearchValue('')
            const Value = [...new Set(value.replace(/ |#|'|_\d+/g, ",").split(',').map(i => i.trim()).filter(i => !!i && !batch.includes(i) && i))]
            setBatch([...batch, ...Value])
        } else {
            setSearchValue(value)
        }

        setPage(1)
    }

    const handleChangeCreated = (momentArray, dateStringArray) => {
        setCreatedStart(dateStringArray[0])
        setCreatedEnd(dateStringArray[1])
        setPage(1)
    }

    const handleChangePackingCreated = (momentArray, dateStringArray) => {
        setPackingStart(dateStringArray[0])
        setPackingEnd(dateStringArray[1])
        setPage(1)
    }

    const _updateSelectedSku = (id, isAdded) => {
        // const itemsCanChecked = listCombineShip.filter(item => item)
        if (isAdded && !arrSelected.map(i => i._id).includes(id)) {
            const newSelected = [...arrSelected, ...listCombineShip.filter(i => i._id === id)]
            setArrSelected(newSelected)
            const selectAllNew = arrSelected.length + 1 === listCombineShip.length ? true : false
            setSelectAll(selectAllNew)
        } else {
            const filtered = arrSelected.filter(item => item._id !== id)

            setArrSelected(filtered)
            setSelectAll(false)
        }
    }

    const _handleCheckALl = (isChecked) => {
        if (isChecked) {
            const batchShipItems = [...listCombineShip].map(item => item)
            setArrSelected(batchShipItems)
            setSelectAll(true)
        }else{
            setArrSelected([])
            setSelectAll(false)
        }
    }

    const _onGetInfoBox = (orderId, realWeight, realHeight, realWidth, realLength) => {
        // setIsOpenModalInfo(true)
    }

    useEffect(() => {
        fetchCombineShip()
        _handleCheckALl(false)
    }, [status, itemType, lineShip,debounceSearch, createdStart, createdEnd, limit, page, packingStart, packingEnd])

    return (
        <div className='BatchShipPage'>
            <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                <h1 className="PageTitle font-weight-bold mb-0">Quản lý đơn gộp ship</h1>
                <div className="RightTop">
                    <Link to={`/combine-ship/create`} className='btn btn-primary mb-2' style={{ background: '#477BF6' }}>
                        <i className="fa fa-plus mr-1"/>Tạo đơn gộp ship
                    </Link>
                </div>
            </div>
            <div className="SectionInner mt-3 card px-3 py-3">
                <div className="filter align-items-center mt-2">
                    <CombineShipFilter
                        status={status}
                        batch={batch}
                        itemType={itemType}
                        createdStart={createdStart}
                        createdEnd={createdEnd}
                        packingStart={packingStart}
                        packingEnd={packingEnd}
                        lineShip={lineShip}
                        searchValue={searchValue}
                        loading={loading}
                        handleChangeCreated={handleChangeCreated}
                        handleChangeStatus={handleChangeStatus}
                        handleChangeBatch={handleChangeBatch}
                        handleChangeItemType={handleChangeItemType}
                        handleSearchBatch={handleSearchBatch}
                        handleChangeLineShip={handleChangeLineShip}
                        onChangePackingCreated={handleChangePackingCreated}
                    />
                </div>
                {
                    <div>
                        <div className='SkuTotal d-flex justify-content-between align-items-center mb-3'>
                            {
                                total > 0 && <div>
                                    <span>{total}</span> items
                                </div>
                            }
                        </div>
                        <Spin spinning={loading} tip='Data Loading...'>
                            <CombineShipTable
                                selectAll={selectAll}
                                arrSelected={arrSelected}
                                listCombineShip={status && status === 'cancelled' ? listCombineShip : listCombineShip.filter(item => item.status !== 'cancelled')}
                                loading={loading}
                                reload={fetchCombineShip}
                                onCheckALl={_handleCheckALl}
                                onSelected={_updateSelectedSku}
                                onGetInfoBox={_onGetInfoBox}
                            />
                            <Pagination
                                pageSizeOptions={['10', '20', '50', '100']}
                                onChange={handlePageChange}
                                className='text-right'
                                pageSize={limit}
                                showSizeChanger
                                current={page}
                                total={total}
                            />
                        </Spin>

                        {/* <ModalEditInfoBox
                            // boxes={boxes}
                            boxId={orderId}
                            realWeight={realWeight}
                            realHeight={realHeight}
                            realWidth={realWidth}
                            realLength={realLength}
                            isOpen={isOpenModalInfo}
                            className="EditInfoBox"
                            onToggleModal={_togglePopupModalEdit}
                            onReloadBox={fetchBatchShip}
                        /> */}
                    </div>
                }
            </div>
        </div>
    )
}

export default CombineShipPage